import { Section } from '../../orderProducts.types';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByDefault extends OrderProductsBuilder {
  public group({ orderProducts }: OrderProductsGroupProps): Section[] {
    return [
      {
        addProducts: [],
        productsCount: orderProducts.length,
        deliveryWindow: undefined,
        availability: undefined,
        isExpanded: true,
        products: orderProducts,
      },
    ];
  }
}

export default OrderProductsGroupByDefault;
